import { motion } from 'framer-motion'
import { CheckCircle, Clock } from 'lucide-react'
import { PLANS } from '../constants/pricing'
import { APP_REGISTER_URL } from '../constants/nav'
import FadeIn from '../components/animations/FadeIn'
import StaggerContainer, { StaggerItem } from '../components/animations/StaggerContainer'

export default function Pricing() {
  return (
    <section className="bg-off-white py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeIn className="text-center mb-12">
          <p className="section-label mb-3">Pricing</p>
          <h1 className="text-navy text-2xl sm:text-[36px] font-heading font-semibold">
            Simple plans. No surprises.
          </h1>
        </FadeIn>

        <StaggerContainer className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PLANS.map((plan) => (
            <StaggerItem key={plan.name}>
              <motion.div
                whileHover={{ y: -6, boxShadow: plan.featured ? '0 16px 40px rgba(0,0,0,0.15)' : '0 12px 32px rgba(0,0,0,0.08)' }}
                transition={{ duration: 0.25, ease: [0.25, 0.1, 0.25, 1] }}
                className={`rounded-xl p-6 h-full flex flex-col ${
                  plan.featured
                    ? 'bg-navy border-2 border-field-orange relative'
                    : 'bg-white border border-gray-100'
                }`}
              >
                {plan.featured && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-field-orange text-white text-xs font-medium px-3 py-1 rounded-full">
                    Most popular
                  </span>
                )}
                <h3 className={`font-heading font-semibold mb-1 ${plan.featured ? 'text-white' : 'text-navy'}`}>
                  {plan.name}
                </h3>
                <p className={`text-2xl font-heading font-semibold mb-1 ${plan.featured ? 'text-white' : 'text-navy'}`}>
                  {plan.price}
                </p>
                <p className={`text-sm mb-4 ${plan.featured ? 'text-white/60' : 'text-slate'}`}>{plan.users}</p>

                <ul className="space-y-2 mb-6 flex-1">
                  {plan.included.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm">
                      <CheckCircle className="w-4 h-4 mt-0.5 shrink-0 text-site-green" />
                      <span className={plan.featured ? 'text-white/90' : 'text-navy'}>{item}</span>
                    </li>
                  ))}
                  {plan.locked.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm">
                      <Clock className="w-4 h-4 mt-0.5 shrink-0 text-slate" />
                      <span className="text-slate">{item}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href={APP_REGISTER_URL}
                  className={plan.featured ? 'btn-primary w-full text-center' : 'btn-outline w-full text-center'}
                >
                  {plan.cta}
                </a>
              </motion.div>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  )
}
